export * from './common/oauth.types';
export * from './common/oauth.provider';
import './logger';
export * from './components/OAuthCallback';
// @ts-ignore
import pj from './package.json';
export var version = pj.version;
//# sourceMappingURL=index.js.map